import { useState, useEffect } from "react";

// ─── Styles ───────────────────────────────────────────────────────────────────

const s = {
  container: { padding: "20px", maxWidth: "900px", margin: "0 auto" },
  message: { textAlign: "center", color: "#94a3b8", padding: "24px", fontStyle: "italic" },
  errorMsg: { textAlign: "center", color: "#ef4444", padding: "24px" },
  sectionTitle: {
    fontSize: "15px", fontWeight: 600, color: "#e2e8f0",
    marginBottom: "14px", borderBottom: "1px solid #334155", paddingBottom: "8px",
  },
  // Image card (list row)
  imageCard: {
    display: "flex", alignItems: "center", gap: "14px",
    background: "#1e293b", border: "1px solid #334155",
    borderRadius: "8px", padding: "10px",
  },
  thumbWrap: {
    flexShrink: 0, width: 80, height: 60, borderRadius: "4px",
    overflow: "hidden", cursor: "pointer", background: "#0f172a",
  },
  thumb: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  cardInfo: { flex: 1, display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 },
  cardName: {
    fontSize: "14px", fontWeight: 600, color: "#e2e8f0",
    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  },
  infoRow: { display: "flex", gap: "6px", fontSize: "12px", color: "#94a3b8" },
  infoLabel: { color: "#475569", minWidth: 82, flexShrink: 0 },
  mono: { fontFamily: "monospace", fontSize: "11px", wordBreak: "break-all" },
  deleteBtn: {
    flexShrink: 0, background: "transparent", border: "1px solid #ef4444",
    color: "#ef4444", borderRadius: "6px", padding: "6px 10px",
    cursor: "pointer", fontSize: "16px", lineHeight: 1,
  },
  restoreBtn: {
    flexShrink: 0, background: "transparent", border: "1px solid #22c55e",
    color: "#22c55e", borderRadius: "6px", padding: "6px 10px",
    cursor: "pointer", fontSize: "16px", lineHeight: 1,
  },
  // Trash section toggle
  trashSectionBtn: {
    display: "flex", alignItems: "center", gap: "8px",
    background: "transparent", border: "1px solid #334155", color: "#e2e8f0",
    borderRadius: "8px", padding: "12px 16px", fontSize: "15px", fontWeight: 600,
    cursor: "pointer", width: "100%", marginTop: "32px",
  },
  // Vehicle class tiles
  classGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    gap: "14px",
  },
  classTile: {
    background: "#1e293b", border: "1px solid #334155",
    borderRadius: "8px", overflow: "hidden", cursor: "pointer",
  },
  classTileAspect: { width: "100%", paddingTop: "66%", position: "relative", background: "#0f172a" },
  classTileImg: {
    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
    width: "100%", height: "100%", objectFit: "cover",
  },
  classTileNoImg: {
    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#475569", fontSize: "22px",
  },
  classTileFooter: { padding: "8px 10px" },
  classTileId: { fontSize: "13px", fontWeight: 600, color: "#e2e8f0" },
  classTileCount: { fontSize: "11px", color: "#64748b", marginTop: "2px" },
  // Pagination
  pagination: {
    display: "flex", alignItems: "center", justifyContent: "center",
    gap: "12px", marginTop: "20px",
  },
  pageBtn: {
    background: "transparent", border: "1px solid #334155", color: "#94a3b8",
    borderRadius: "6px", padding: "6px 14px", fontSize: "13px", cursor: "pointer",
  },
  pageBtnDisabled: {
    background: "transparent", border: "1px solid #1e293b", color: "#334155",
    borderRadius: "6px", padding: "6px 14px", fontSize: "13px", cursor: "not-allowed",
  },
  pageInfo: { fontSize: "13px", color: "#64748b" },
  // Back button
  backBtn: {
    background: "transparent", border: "1px solid #334155",
    color: "#94a3b8", borderRadius: "6px", padding: "6px 14px",
    fontSize: "14px", cursor: "pointer", marginBottom: "20px",
  },
  imageGrid: { display: "flex", flexDirection: "column", gap: "10px" },
  // Preview modal
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
  },
  modal: {
    background: "#1e293b", border: "1px solid #334155", borderRadius: "12px",
    padding: "24px", maxWidth: "min(700px, 92vw)", maxHeight: "90vh",
    overflow: "auto", display: "flex", flexDirection: "column", gap: "18px",
    position: "relative",
  },
  modalCloseBtn: {
    position: "absolute", top: "10px", right: "12px",
    background: "transparent", border: "none", color: "#94a3b8",
    fontSize: "24px", cursor: "pointer", lineHeight: 1, padding: "4px 8px",
  },
  modalImg: {
    maxWidth: "100%", maxHeight: "55vh", objectFit: "contain",
    borderRadius: "6px", alignSelf: "center",
  },
  metaGrid: { display: "flex", flexDirection: "column", gap: "10px" },
  metaRow: { display: "flex", alignItems: "center", gap: "12px" },
  metaLabel: { fontSize: "12px", color: "#64748b", minWidth: 88, flexShrink: 0 },
  metaValue: { fontSize: "13px", color: "#e2e8f0" },
  metaInput: {
    flex: 1, background: "#0f172a", border: "1px solid #334155",
    borderRadius: "6px", color: "#94a3b8", padding: "6px 10px",
    fontSize: "13px", fontFamily: "inherit",
  },
  modalActions: { display: "flex", gap: "10px", marginTop: "4px" },
  saveBtn: {
    background: "#3b82f6", color: "white", border: "none",
    borderRadius: "6px", padding: "8px 18px", fontSize: "14px",
    fontWeight: 600, cursor: "pointer", alignSelf: "flex-start",
  },
  saveBtnDisabled: {
    background: "#3b82f6", color: "white", border: "none",
    borderRadius: "6px", padding: "8px 18px", fontSize: "14px",
    fontWeight: 600, cursor: "not-allowed", alignSelf: "flex-start",
    opacity: 0.4,
  },
  spawnBtn: {
    background: "transparent", color: "#a78bfa", border: "1px solid #a78bfa",
    borderRadius: "6px", padding: "8px 18px", fontSize: "14px",
    fontWeight: 600, cursor: "pointer", alignSelf: "flex-start",
  },
  spawnBtnDisabled: {
    background: "transparent", color: "#a78bfa", border: "1px solid #a78bfa",
    borderRadius: "6px", padding: "8px 18px", fontSize: "14px",
    fontWeight: 600, cursor: "not-allowed", alignSelf: "flex-start",
    opacity: 0.4,
  },
  restoreModalBtn: {
    background: "#22c55e", color: "white", border: "none",
    borderRadius: "6px", padding: "8px 18px", fontSize: "14px",
    fontWeight: 600, cursor: "pointer", alignSelf: "flex-start", marginTop: "4px",
  },
};

// ─── ImageCard ────────────────────────────────────────────────────────────────

function ImageCard({ image, savedHost, onDelete, deleting, onPreview }) {
  return (
    <div style={s.imageCard}>
      <div style={s.thumbWrap} onClick={() => onPreview(image)}>
        <img
          src={`${savedHost}/api/vehicles/image/${image.uniqueId}?width=300`}
          alt={image.name || image.uniqueId}
          style={s.thumb}
        />
      </div>
      <div style={s.cardInfo}>
        <div style={s.cardName}>{image.name || "Unbekannt"}</div>
        <div style={s.infoRow}><span style={s.infoLabel}>Fahrzeug-ID</span>{image.vehicleId}</div>
        <div style={s.infoRow}>
          <span style={s.infoLabel}>Unique ID</span>
          <span style={s.mono}>{image.uniqueId}</span>
        </div>
        <div style={s.infoRow}>
          <span style={s.infoLabel}>Hochgeladen</span>
          {new Date(image.storedAt).toLocaleString("de-DE")}
        </div>
        <div style={s.infoRow}>
          <span style={s.infoLabel}>Größe</span>
          {(image.fileSize / 1024 / 1024).toFixed(2)} MB
        </div>
        {image.uploader && (
          <div style={s.infoRow}><span style={s.infoLabel}>Uploader</span>{image.uploader}</div>
        )}
      </div>
      <button
        style={{ ...s.deleteBtn, opacity: deleting ? 0.4 : 1, cursor: deleting ? "not-allowed" : "pointer" }}
        onClick={() => onDelete(image.uniqueId)}
        disabled={deleting}
        title="In den Papierkorb verschieben"
      >
        {deleting ? "⏳" : "🗑️"}
      </button>
    </div>
  );
}

// ─── ImagePreviewModal ────────────────────────────────────────────────────────

function ImagePreviewModal({ image, savedHost, onClose, onUpdated, onAuthError }) {
  const [name, setName] = useState(image.name || "");
  const [uploader, setUploader] = useState(image.uploader || "");
  const [saveState, setSaveState] = useState("idle");
  const [spawnState, setSpawnState] = useState("idle");

  const dirty = name !== (image.name || "") || uploader !== (image.uploader || "");

  const handleSave = async () => {
    setSaveState("saving");
    const res = await fetch(`${savedHost}/api/vehicles/image/${image.uniqueId}`, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, uploader }),
    });
    if (res.status === 401) { onAuthError?.(); setSaveState("idle"); return; }
    if (!res.ok) {
      const d = await res.json();
      alert(`Fehler: ${d.error || "Unbekannt"}`);
      setSaveState("idle");
      return;
    }
    const updated = await res.json();
    onUpdated?.(updated);
    setSaveState("done");
    setTimeout(() => setSaveState("idle"), 2000);
  };

  const handleSpawn = async () => {
    setSpawnState("spawning");
    const res = await fetch(`${savedHost}/api/vehicles/spawn/${image.uniqueId}`, {
      method: "POST",
      credentials: "include",
    });
    if (res.status === 401) { onAuthError?.(); setSpawnState("idle"); return; }
    if (!res.ok) {
      const d = await res.json();
      alert(`Fehler: ${d.error || "Unbekannt"}`);
      setSpawnState("idle");
      return;
    }
    setSpawnState("done");
    setTimeout(() => setSpawnState("idle"), 2000);
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={(e) => e.stopPropagation()}>
        <button style={s.modalCloseBtn} onClick={onClose}>×</button>
        <img
          src={`${savedHost}/api/vehicles/image/${image.uniqueId}`}
          alt={image.name || image.uniqueId}
          style={s.modalImg}
        />
        <div style={s.metaGrid}>
          <div style={s.metaRow}>
            <label style={s.metaLabel}>Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={s.metaInput}
              placeholder="Kein Name"
            />
          </div>
          <div style={s.metaRow}>
            <label style={s.metaLabel}>Uploader</label>
            <input
              value={uploader}
              onChange={(e) => setUploader(e.target.value)}
              style={s.metaInput}
              placeholder="Unbekannt"
            />
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Fahrzeug-ID</span>
            <span style={s.metaValue}>{image.vehicleId}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Unique ID</span>
            <span style={{ ...s.metaValue, ...s.mono, fontSize: 11 }}>{image.uniqueId}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Hochgeladen</span>
            <span style={s.metaValue}>{new Date(image.storedAt).toLocaleString("de-DE")}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Dateigröße</span>
            <span style={s.metaValue}>{(image.fileSize / 1024 / 1024).toFixed(2)} MB</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Typ</span>
            <span style={s.metaValue}>{image.contentType}</span>
          </div>
          <div style={s.modalActions}>
            <button
              style={dirty && saveState !== "saving" ? s.saveBtn : s.saveBtnDisabled}
              onClick={handleSave}
              disabled={!dirty || saveState === "saving"}
            >
              {saveState === "saving" ? "Speichern..." : saveState === "done" ? "✅ Gespeichert" : "Speichern"}
            </button>
            <button
              style={spawnState === "spawning" ? s.spawnBtnDisabled : s.spawnBtn}
              onClick={handleSpawn}
              disabled={spawnState === "spawning"}
              title="Fahrzeug in der Anwendung spawnen"
            >
              {spawnState === "spawning" ? "⏳ Spawnen..." : spawnState === "done" ? "✅ Gespawnt" : "🚀 Spawnen"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── VehicleClassTile ─────────────────────────────────────────────────────────

function VehicleClassTile({ summary, savedHost, onClick }) {
  return (
    <div style={s.classTile} onClick={onClick}>
      <div style={s.classTileAspect}>
        {summary.previewUniqueId ? (
          <img
            src={`${savedHost}/api/vehicles/image/${summary.previewUniqueId}?width=300`}
            alt={`Fahrzeug ${summary.vehicleId}`}
            style={s.classTileImg}
          />
        ) : (
          <div style={s.classTileNoImg}>–</div>
        )}
      </div>
      <div style={s.classTileFooter}>
        <div style={s.classTileId}>ID {summary.vehicleId}</div>
        <div style={s.classTileCount}>{summary.count} Scan{summary.count !== 1 ? "s" : ""}</div>
      </div>
    </div>
  );
}

// ─── TrashItemCard ────────────────────────────────────────────────────────────

function TrashItemCard({ item, savedHost, onRestore, onPreview, restoring }) {
  return (
    <div style={s.imageCard}>
      <div style={s.thumbWrap} onClick={() => onPreview(item)}>
        <img
          src={`${savedHost}/api/vehicles/image/${item.uniqueId}?width=300`}
          alt={item.name || item.uniqueId}
          style={s.thumb}
        />
      </div>
      <div style={s.cardInfo}>
        <div style={s.cardName}>{item.name || "Unbekannt"}</div>
        <div style={s.infoRow}><span style={s.infoLabel}>Fahrzeug-ID</span>{item.vehicleId}</div>
        <div style={s.infoRow}>
          <span style={s.infoLabel}>Unique ID</span>
          <span style={s.mono}>{item.uniqueId}</span>
        </div>
        <div style={s.infoRow}>
          <span style={s.infoLabel}>Gelöscht am</span>
          {new Date(item.deletedAt).toLocaleString("de-DE")}
        </div>
      </div>
      <button
        style={{ ...s.restoreBtn, opacity: restoring ? 0.4 : 1, cursor: restoring ? "not-allowed" : "pointer" }}
        onClick={() => onRestore(item)}
        disabled={restoring}
        title="Wiederherstellen"
      >
        {restoring ? "⏳" : "↩️"}
      </button>
    </div>
  );
}

// ─── TrashPreviewModal ────────────────────────────────────────────────────────

function TrashPreviewModal({ item, savedHost, onClose, onRestore, restoring }) {
  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={(e) => e.stopPropagation()}>
        <button style={s.modalCloseBtn} onClick={onClose}>×</button>
        <img
          src={`${savedHost}/api/vehicles/image/${item.uniqueId}`}
          alt={item.name || item.uniqueId}
          style={s.modalImg}
        />
        <div style={s.metaGrid}>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Name</span>
            <span style={s.metaValue}>{item.name || "Unbekannt"}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Fahrzeug-ID</span>
            <span style={s.metaValue}>{item.vehicleId}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Unique ID</span>
            <span style={{ ...s.metaValue, ...s.mono, fontSize: 11 }}>{item.uniqueId}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Hochgeladen</span>
            <span style={s.metaValue}>{new Date(item.storedAt).toLocaleString("de-DE")}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Gelöscht am</span>
            <span style={s.metaValue}>{new Date(item.deletedAt).toLocaleString("de-DE")}</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Dateigröße</span>
            <span style={s.metaValue}>{(item.fileSize / 1024 / 1024).toFixed(2)} MB</span>
          </div>
          <div style={s.metaRow}>
            <span style={s.metaLabel}>Typ</span>
            <span style={s.metaValue}>{item.contentType}</span>
          </div>
          <button
            style={{ ...s.restoreModalBtn, opacity: restoring ? 0.4 : 1, cursor: restoring ? "not-allowed" : "pointer" }}
            onClick={() => onRestore(item)}
            disabled={restoring}
          >
            {restoring ? "⏳ Wird wiederhergestellt..." : "↩️ Wiederherstellen"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── CarList ──────────────────────────────────────────────────────────────────

const PAGE_SIZE = 10;

function CarList({ savedHost, onAuthError }) {
  const [latestImages, setLatestImages] = useState([]);
  const [vehicleClasses, setVehicleClasses] = useState([]);
  const [totalClasses, setTotalClasses] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedClass, setSelectedClass] = useState(null);
  const [classImages, setClassImages] = useState([]);
  const [classPage, setClassPage] = useState(1);
  const [classLoading, setClassLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [showTrash, setShowTrash] = useState(false);
  const [trashItems, setTrashItems] = useState([]);
  const [trashTotal, setTrashTotal] = useState(0);
  const [trashPage, setTrashPage] = useState(1);
  const [trashTotalPages, setTrashTotalPages] = useState(1);
  const [trashLoading, setTrashLoading] = useState(false);
  const [restoringId, setRestoringId] = useState(null);
  const [previewTrashItem, setPreviewTrashItem] = useState(null);

  const handle401 = () => onAuthError?.();

  const loadMainPage = async (page, { silent = false } = {}) => {
    try {
      if (!silent) setLoading(true);
      const [latestRes, classesRes] = await Promise.all([
        fetch(`${savedHost}/api/vehicles/latest/5`, { credentials: "include" }),
        fetch(`${savedHost}/api/vehicles?page=${page}&limit=${PAGE_SIZE}`, { credentials: "include" }),
      ]);
      if (latestRes.status === 401 || classesRes.status === 401) { handle401(); return; }
      if (!latestRes.ok || !classesRes.ok) throw new Error("Ladefehler");
      const [latest, paged] = await Promise.all([latestRes.json(), classesRes.json()]);
      setLatestImages(latest);
      setVehicleClasses(paged.items);
      setTotalClasses(paged.total);
      setTotalPages(paged.pages);
      setCurrentPage(paged.page);
    } catch (err) {
      if (!silent) setError(err.message);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => { loadMainPage(1); }, [savedHost]);

  const loadTrash = async (page) => {
    try {
      setTrashLoading(true);
      const res = await fetch(`${savedHost}/api/vehicles/trash?page=${page}&limit=${PAGE_SIZE}`, {
        credentials: "include",
      });
      if (res.status === 401) { handle401(); return; }
      if (!res.ok) throw new Error("Ladefehler");
      const data = await res.json();
      setTrashItems(data.items);
      setTrashTotal(data.total);
      setTrashTotalPages(data.pages);
      setTrashPage(data.page);
    } catch (err) {
      setError(err.message);
    } finally {
      setTrashLoading(false);
    }
  };

  const openTrash = () => {
    setShowTrash(true);
    loadTrash(1);
  };

  const goToTrashPage = (page) => {
    if (page < 1 || page > trashTotalPages) return;
    loadTrash(page);
  };

  const handleRestore = async (item) => {
    setRestoringId(item.uniqueId);
    try {
      const res = await fetch(`${savedHost}/api/vehicles/trash/${item.uniqueId}/restore`, {
        method: "POST",
        credentials: "include",
      });
      if (res.status === 401) { handle401(); return; }
      if (!res.ok) {
        const d = await res.json();
        alert(`Fehler: ${d.error || "Unbekannt"}`);
        return;
      }

      fetch(`${savedHost}/api/vehicles/spawn/${item.uniqueId}`, {
        method: "POST",
        credentials: "include",
      }).catch(() => {});

      setTrashItems((prev) => prev.filter((i) => i.uniqueId !== item.uniqueId));
      setTrashTotal((prev) => Math.max(0, prev - 1));
      setPreviewTrashItem((prev) => (prev?.uniqueId === item.uniqueId ? null : prev));
      loadMainPage(currentPage, { silent: true });
    } finally {
      setRestoringId(null);
    }
  };

  const openClass = async (summary) => {
    setSelectedClass(summary);
    setClassLoading(true);
    setClassImages([]);
    setClassPage(1);
    try {
      const res = await fetch(`${savedHost}/api/vehicles/class/${summary.vehicleId}`, {
        credentials: "include",
      });
      if (res.status === 401) { handle401(); return; }
      if (res.ok) setClassImages(await res.json());
    } finally {
      setClassLoading(false);
    }
  };

  const handleDelete = async (uniqueId) => {
    if (!confirm(`Bild "${uniqueId}" in den Papierkorb verschieben?`)) return;
    setDeletingId(uniqueId);
    try {
      const res = await fetch(`${savedHost}/api/vehicles/image/${uniqueId}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (res.status === 401) { handle401(); return; }
      if (!res.ok) {
        const d = await res.json();
        alert(`Fehler: ${d.error || "Unbekannt"}`);
        return;
      }

      setLatestImages((prev) => prev.filter((i) => i.uniqueId !== uniqueId));
      setClassImages((prev) => prev.filter((i) => i.uniqueId !== uniqueId));

      // Update class tiles — reload current page if a class becomes empty
      setVehicleClasses((prev) => {
        const updated = prev
          .map((v) => v.vehicleId === selectedClass?.vehicleId
            ? { ...v, count: v.count - 1 }
            : v)
          .filter((v) => v.count > 0);
        return updated;
      });
      setSelectedClass((prev) => {
        if (!prev) return null;
        const newCount = prev.count - 1;
        return newCount === 0 ? null : { ...prev, count: newCount };
      });
    } finally {
      setDeletingId(null);
    }
  };

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    loadMainPage(page);
  };

  const handleImageUpdated = (updated) => {
    setLatestImages((prev) => prev.map((i) => (i.uniqueId === updated.uniqueId ? { ...i, ...updated } : i)));
    setClassImages((prev) => prev.map((i) => (i.uniqueId === updated.uniqueId ? { ...i, ...updated } : i)));
    setPreviewImage((prev) => (prev?.uniqueId === updated.uniqueId ? { ...prev, ...updated } : prev));
  };

  if (loading) return <div style={s.message}>Lade Fahrzeuge...</div>;
  if (error) return <div style={s.errorMsg}>Fehler: {error}</div>;

  // ── Class detail view ──────────────────────────────────────────────────────
  if (selectedClass) {
    const classTotalPages = Math.ceil(classImages.length / PAGE_SIZE);
    const pagedImages = classImages.slice((classPage - 1) * PAGE_SIZE, classPage * PAGE_SIZE);

    return (
      <div style={s.container}>
        <button style={s.backBtn} onClick={() => setSelectedClass(null)}>← Zurück</button>
        <h3 style={s.sectionTitle}>
          Fahrzeug-ID: {selectedClass.vehicleId} · {classImages.length || selectedClass.count} Scan{selectedClass.count !== 1 ? "s" : ""}
        </h3>
        {classLoading ? (
          <div style={s.message}>Lade Bilder...</div>
        ) : (
          <>
            <div style={s.imageGrid}>
              {pagedImages.map((img) => (
                <ImageCard
                  key={img.uniqueId}
                  image={img}
                  savedHost={savedHost}
                  onDelete={handleDelete}
                  deleting={deletingId === img.uniqueId}
                  onPreview={setPreviewImage}
                />
              ))}
            </div>
            {classTotalPages > 1 && (
              <div style={s.pagination}>
                <button
                  style={classPage <= 1 ? s.pageBtnDisabled : s.pageBtn}
                  onClick={() => setClassPage((p) => Math.max(1, p - 1))}
                  disabled={classPage <= 1}
                >
                  ← Zurück
                </button>
                <span style={s.pageInfo}>Seite {classPage} / {classTotalPages}</span>
                <button
                  style={classPage >= classTotalPages ? s.pageBtnDisabled : s.pageBtn}
                  onClick={() => setClassPage((p) => Math.min(classTotalPages, p + 1))}
                  disabled={classPage >= classTotalPages}
                >
                  Weiter →
                </button>
              </div>
            )}
          </>
        )}
        {previewImage && (
          <ImagePreviewModal image={previewImage} savedHost={savedHost} onClose={() => setPreviewImage(null)} />
        )}
      </div>
    );
  }

  // ── Trash view ──────────────────────────────────────────────────────────────
  if (showTrash) {
    return (
      <div style={s.container}>
        <button style={s.backBtn} onClick={() => setShowTrash(false)}>← Zurück</button>
        <h3 style={s.sectionTitle}>
          Papierkorb{trashTotal > 0 ? ` (${trashTotal})` : ""}
        </h3>
        {trashLoading ? (
          <div style={s.message}>Lade Papierkorb...</div>
        ) : trashItems.length === 0 ? (
          <div style={s.message}>Papierkorb ist leer.</div>
        ) : (
          <>
            <div style={s.imageGrid}>
              {trashItems.map((item) => (
                <TrashItemCard
                  key={item.uniqueId}
                  item={item}
                  savedHost={savedHost}
                  onRestore={handleRestore}
                  onPreview={setPreviewTrashItem}
                  restoring={restoringId === item.uniqueId}
                />
              ))}
            </div>
            {trashTotalPages > 1 && (
              <div style={s.pagination}>
                <button
                  style={trashPage <= 1 ? s.pageBtnDisabled : s.pageBtn}
                  onClick={() => goToTrashPage(trashPage - 1)}
                  disabled={trashPage <= 1}
                >
                  ← Zurück
                </button>
                <span style={s.pageInfo}>Seite {trashPage} / {trashTotalPages}</span>
                <button
                  style={trashPage >= trashTotalPages ? s.pageBtnDisabled : s.pageBtn}
                  onClick={() => goToTrashPage(trashPage + 1)}
                  disabled={trashPage >= trashTotalPages}
                >
                  Weiter →
                </button>
              </div>
            )}
          </>
        )}
        {previewTrashItem && (
          <TrashPreviewModal
            item={previewTrashItem}
            savedHost={savedHost}
            onClose={() => setPreviewTrashItem(null)}
            onRestore={handleRestore}
            restoring={restoringId === previewTrashItem.uniqueId}
          />
        )}
      </div>
    );
  }

  // ── Main view ──────────────────────────────────────────────────────────────
  return (
    <div style={s.container}>
      <h3 style={s.sectionTitle}>Zuletzt hochgeladen</h3>
      {latestImages.length === 0 ? (
        <div style={s.message}>Keine Bilder vorhanden.</div>
      ) : (
        <div style={s.imageGrid}>
          {latestImages.map((img) => (
            <ImageCard
              key={img.uniqueId}
              image={img}
              savedHost={savedHost}
              onDelete={handleDelete}
              deleting={deletingId === img.uniqueId}
              onPreview={setPreviewImage}
            />
          ))}
        </div>
      )}

      <h3 style={{ ...s.sectionTitle, marginTop: 32 }}>
        Fahrzeugklassen{totalClasses > 0 ? ` (${totalClasses})` : ""}
      </h3>
      {vehicleClasses.length === 0 ? (
        <div style={s.message}>Keine Fahrzeugklassen vorhanden.</div>
      ) : (
        <>
          <div style={s.classGrid}>
            {vehicleClasses.map((summary) => (
              <VehicleClassTile
                key={summary.vehicleId}
                summary={summary}
                savedHost={savedHost}
                onClick={() => openClass(summary)}
              />
            ))}
          </div>
          {totalPages > 1 && (
            <div style={s.pagination}>
              <button
                style={currentPage <= 1 ? s.pageBtnDisabled : s.pageBtn}
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage <= 1}
              >
                ← Zurück
              </button>
              <span style={s.pageInfo}>Seite {currentPage} / {totalPages}</span>
              <button
                style={currentPage >= totalPages ? s.pageBtnDisabled : s.pageBtn}
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage >= totalPages}
              >
                Weiter →
              </button>
            </div>
          )}
        </>
      )}

      <button style={s.trashSectionBtn} onClick={openTrash}>
        🗑️ Papierkorb
      </button>

      {previewImage && (
        <ImagePreviewModal
          image={previewImage}
          savedHost={savedHost}
          onClose={() => setPreviewImage(null)}
          onUpdated={handleImageUpdated}
          onAuthError={handle401}
        />
      )}
    </div>
  );
}

export default CarList;
